// tslint:disable: completed-docs
import { TRIGGERNEXTOVERLAY } from 'Constant';
import {
    TOGGLE_DEFAULT_NOTIFICATION,
    SELECT_MULTIPICKER,
    SELECT_MULTIPICKER_SUCCESS,
    SET_DEFAULT_STATE,
    OFFER_GETS_VISIBLE,
    OFFER_ALREADY_VISIBLE_ON_PAGELOAD,
    NOTIFICATION_HOTLINE_LINK_CLICK,
    PRE_SELECT_MULTIPICKER_SUCCESS,
    FAQ_ACCORDION_TOGGLE,
    GET_OFFERS,
    GET_OFFERS_FAILED,
    GET_OFFERS_SUCCESS,
    GET_ADDITIONAL_CONTENTS,
    GET_ADDITIONAL_CONTENTS_FAILED,
    GET_ADDITIONAL_CONTENTS_SUCCESS,
} from './constant';

/**
 * sets Default State
 */
export const setDefaultState = (additionalCMSOptions: {}, param_offer: string) => {
    return {
        type: SET_DEFAULT_STATE,
        additionalCMSOptions,
        param_offer,
    };
};

/**
 * sets the multipicker-items the user has selected
 */
export const selectMultiPicker = (value, checked) => {
    return {
        type: SELECT_MULTIPICKER,
        value,
        checked,
    };
};
export const selectMultiPickerSuccess = (offerKeys) => {
    return {
        type: SELECT_MULTIPICKER_SUCCESS,
        offerKeys,
    };
};

/**
 * displays a notification box when no offer is found for the
 * user's selection and the default offer(s) is/are displayed
 */
export const toggleDefaultNotification = (showNotification) => {
    return {
        type: TOGGLE_DEFAULT_NOTIFICATION,
        showNotification,
    };
};

/**
 * Event, when offer gets into viewport
 */
export const offerGetsVisible = () => {
    return {
        type: OFFER_GETS_VISIBLE,
    };
};

/**
 * Event, when offer is already viewport on page loading
 */
export const offerAlreadyVisible = () => {
    return {
        type: OFFER_ALREADY_VISIBLE_ON_PAGELOAD,
    };
};

/**
 * Event, when Hotline Link in Notification is clicked
 */
export const notificationHotlineLinkClick = (phoneNumber) => {
    return {
        type: NOTIFICATION_HOTLINE_LINK_CLICK,
        phoneNumber,
    };
};

/**
 * Event, when Hotline Link in Notification is clicked
 */
export const preSelectMultipickerSuccess = (offerKeys) => {
    return {
        type: PRE_SELECT_MULTIPICKER_SUCCESS,
        offerKeys,
    };
};

/**
 * Event, when Hotline Link in Notification is clicked
 */
export const toggleFaqAccordion = (accordionItemId?: string, isOpen?: boolean) => {
    return {
        type: FAQ_ACCORDION_TOGGLE,
        accordionItemId,
        isOpen,
    };
};
/**
 * offer handling: Load Offer JSON
 */
export const getOffers = (jsonUrl: string) => {
    return {
        type: GET_OFFERS,
        jsonUrl,
    };
};
export const getOffersSuccess = (offers) => {
    return {
        type: GET_OFFERS_SUCCESS,
        offers,
    };
};
export const getOffersFailed = (errorMessage: any) => {
    return {
        type: GET_OFFERS_FAILED,
        errorMessage,
    };
};

/**
 * Export getAdditionalContents
 *
 * @export getAdditionalContents
 */
export const getAdditionalContents = () => {
    return {
        type: GET_ADDITIONAL_CONTENTS,
    };
};

/**
 * Export getAdditionalContentsSuccess
 *
 * @export getAdditionalContentsSuccess
 */
export const getAdditionalContentsSuccess = () => {
    return {
        type: GET_ADDITIONAL_CONTENTS_SUCCESS,
    };
};

/**
 * Export getAdditionalContentsFailed
 *
 * @export getAdditionalContentsFailed
 */
export const getAdditionalContentsFailed = (error) => {
    return {
        type: GET_ADDITIONAL_CONTENTS_FAILED,
        error,
    };
};

/**
 * Export triggerOverlay
 *
 * @export triggerOverlay
 */
export function triggerOverlay(url, name) {
    return {
        type: TRIGGERNEXTOVERLAY,
        url,
        name,
    };
}
